export const dashboardConfigs = {
    title: 'Sales Dashboard',
};

export enum Tabs {
    REPORT_DASHBOARD = 'report_dashboard',
    DOWNLOAD_HISTORY = 'download_history',
}
